import { CrudConsumer, CrudConsumerObject } from "consumerjs";
import { excludeUnserializableFields } from "consumerjs/src/utils";
import { includeLanguagePrefix } from "../utils/general";

/**
 * A received EducationLevel object.
 * @class
 */
class EducationLevel extends CrudConsumerObject {}

/**
 * Provides logic for creating, reading, updating and deleting EducationLevel objects.
 * @class
 */
export class EducationLevelConsumer extends CrudConsumer {
    constructor(
        endpoint = "/api/education-levels/",
        objectClass = EducationLevel
    ) {
        super(includeLanguagePrefix(endpoint), objectClass);
    }

    /**
     * Retrieve all the education levels
     * @return {Promise}
     */
    list = () => {
        return this.get("").then((levels = []) => {
            return (
                levels
                    .map(level => excludeUnserializableFields(level))
                    // TODO remove on backend side if not used anywhere
                    .filter(level => level.value !== "60phd")
            );
        });
    };
}
